import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BatchInformationDialogData } from '@data-terminal/feature-dialogs/services/batch-information/batch-information-dialog.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/divider';
import { MatButton } from '@angular/material/button';
import { SingleMachineBatchInformationComponent } from '@data-terminal/feature-dialogs/dialogs/batch-information-dialog/single-machine-batch-information';
import { KeyValuePipe } from '@angular/common';
import { BatchInformationService } from '@data-terminal/feature-dialogs/services/batch-information/batch-information.service';

@Component({
    selector: 'data-terminal-batch-information-dialog',
    imports: [TranslateModule, MatButton, MatDivider, SingleMachineBatchInformationComponent, KeyValuePipe],
    templateUrl: './batch-information-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BatchInformationDialogComponent {
    readonly #batchInformationService = inject(BatchInformationService);
    readonly #dialogRef = inject(MatDialogRef<BatchInformationDialogComponent>);
    readonly dialogData: BatchInformationDialogData = inject(MAT_DIALOG_DATA);

    close(): void {
        this.#dialogRef.close();
    }

    exportBatchInformation(): void {
        this.#batchInformationService.exportBatchInformationToCsv(
            this.dialogData.batchInformation,
            this.dialogData.jobId
        );
    }
}
